import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { KeyTransactionPageRoutingModule } from './key-transaction-routing.module';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCInputModule } from '@wlp/ui-c-input';
import { StateManagerPixModule } from 'src/app/core/shared/modules/state-manager-pix.module';
import { InterceptService } from '../../../../../../../core/intercept/intercept.service';
import { KeyTransactionPage } from './key-transaction.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    KeyTransactionPageRoutingModule,
    UiBsTranslateModule,
    UiCButtonModule,
    UiCInputModule,
    StateManagerPixModule,
  ],
  declarations: [KeyTransactionPage],
  providers: [
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true,
    },
  ],
})
export class KeyTransactionPageModule {}
